import React from 'react';
import { CaretDownFill, CaretUpFill } from 'react-bootstrap-icons';

const PrioritisationFeedbackButton = ({ onClick, isOpen }) => {
  return (
    <button className="d-flex gap-3 align-items-center mt-3" onClick={onClick}>
      {isOpen ? 'Hide' : 'Give'} prioritisation feedback
      {isOpen ? <CaretUpFill size={10} /> : <CaretDownFill size={10} />}
    </button>
  );
};

export default PrioritisationFeedbackButton;
